/* eslint-disable no-restricted-imports */
import React from "react";
import { Box, Button, Modal, Select, MenuItem } from "@material-ui/core";
// import { TextField } from "@mui/material";
// import { InputLabel } from "@mui/material";
// import alpha from "@material-ui/core/styles";
import { FaEdit } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import { InputLabel, InputBase, Snackbar } from "@material-ui/core";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';

// import { alpha, styled } from "@mui/material/styles";
import { styled } from "@material-ui/styles";
import { AddJobTracking, GetJobTracking, DeleteTracking, UpdateTracking } from "../api";
import { shallowEqual, useSelector } from "react-redux";
import MuiAlert from '@material-ui/lab/Alert';
import moment from "moment";
// import InputBase from "@mui/material/InputBase";
// import InputBase from "@mater";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#F3F6F9" : "#1A2027",
    border: "1px solid",
    borderColor: theme.palette.mode === "light" ? "#E0E3E7" : "#2D3843",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      //   boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      //   borderColor: theme.palette.primary.main,
    },
  },
}));

const tableData = [
  {
    com: "Rolustech",
    loc: "San Diego, CA",
    stat: "Applied",
    role: "Product Manager",
    mc: "John Doe",
    phone: "999-999-999",
    mail: "xyz@example.com",
  },
  {
    com: "Rolustech",
    loc: "San Diego, CA",
    stat: "Not Applied",
    role: "Product Manager",
    mc: "John Doe",
    phone: "999-999-999",
    mail: "xyz@example.com",
  },
  {
    com: "Rolustech",
    loc: "San Diego, CA",
    stat: "Not Applied",
    role: "Product Manager",
    mc: "John Doe",
    phone: "999-999-999",
    mail: "xyz@example.com",
  },
  {
    com: "Rolustech",
    loc: "San Diego, CA",
    stat: "Applied",
    role: "Product Manager",
    mc: "John Doe",
    phone: "999-999-999",
    mail: "xyz@example.com",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  // width: 400,
  // border: '2px solid #000',
  // pt: 2,
  // px: 4,
  // pb: 3,
};

function JobTrackerM() {
  const [open, setOpen] = React.useState(false);
  const [list, setList] = React.useState([]);

  const [snackbar, setSnackbar] = React.useState(() => ({
    isOpen: false,
    message: '',
    type: 'success'
  })) 

  const [pending, setPending] = React.useState(false);

  const { user } = useSelector(({ auth }) => auth, shallowEqual);

  const [addJobTracking, setAddJobTracking] = React.useState({
    jobseekerId: user.id,
    company: null,
    location: null,
    status: null,
    rolePosition: null,
    mainContact: null,
    phone: null,
    email: null,
    dateApplied: null,
    dateContact: null,
    jobLink: null,
    lastUpdatedBy: null,
    tags: [],
  })

  const [addPending, setAddPending] = React.useState(false);
  const [deleteId, setDeleteId] = React.useState(null);
  const [editId, setEditId] = React.useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAddJobTracking({
      jobseekerId: user.id,
      company: null,
      location: null,
      status: null,
      rolePosition: null,
      mainContact: null,
      phone: null,
      email: null,
      dateApplied: null,
      dateContact: null,
      jobLink: null,
      lastUpdatedBy: null,
      tags: [],
    })
    setEditId(null)
    setDeleteId(null)
  };

  React.useEffect(()=>{
    fetchJobTracking()
  }, [])

  React.useEffect(()=>{
    console.log(addJobTracking, 'add object');
  }, [addJobTracking])

  const fetchJobTracking =  async () =>{
    setPending(true);
    try{
      const res = await GetJobTracking(user.id);
      // console.log(res.data, 'res final data');
      setList(res.data);
      // console.log(res.data, 'job tracking');
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      console.log(error);
    }finally{
      setPending(false);
    }
  }

  const handleAddTag = (tag) => {
    if(addJobTracking.tags.includes(tag)){
      setAddJobTracking((pre)=>({
        ...pre,
        tags: addJobTracking.tags.filter((e) => e != tag)
      }))
    }else{
      setAddJobTracking((pre)=>({
        ...pre,
        tags: [...addJobTracking.tags, tag]
      }))
    }
  }

  const handleAddJobTracking = async () =>{
    setAddPending(true);
    try{
      if(editId){
        await UpdateTracking({...addJobTracking, id: editId})
        setSnackbar({
          isOpen: true,
          message: 'Job Updated Successfully',
          type: 'success'
        })
      }else{
        await AddJobTracking(addJobTracking);
        setSnackbar({
          isOpen: true,
          message: 'Job Added Successfully',
          type: 'success'
        })
      }
      // console.log(res.data, 'res final data');
      // setList(res.data);
      
      fetchJobTracking()
      // setAddJobTracking({
      //   jobseekerId: user.id,
      //   company: null,
      //   location: null,
      //   status: null,
      //   rolePosition: null,
      //   mainContact: null,
      //   phone: null,
      //   email: null,
      //   dateApplied: null,
      //   dateContact: null,
      //   jobLink: null,
      //   lastUpdatedBy: null,
      //   tags: [],
      // })
      // setOpen(false)
      handleClose()
      // console.log(res.data, 'job tracking');
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      console.log(error);
    }finally{
      setAddPending(false);
    }
  }

  const handleDeleteJobTracking = async (item) => {
    setDeleteId(item._id);
    try{
      const res = await DeleteTracking(item._id);
      // console.log(res.data, 'res final data');
      // setList(res.data);
      setSnackbar({
        isOpen: true,
        message: 'Job Deleted Successfully',
        type: 'success'
      })
      fetchJobTracking()
      // setOpen(false)
      handleClose()
      // console.log(res.data, 'job tracking');
    }catch(ex){
      let error = ex.response ? ex.response.data.message : ex.message;
      console.log(error);
    }finally{
      setDeleteId(null)
    }
  }

  const setEditModal = (item) => {
    setAddJobTracking((pre)=>({
      ...pre,
      ...item
    }))
    setEditId(item._id);
    setOpen(true);
  }

  return (
    <>
    <Snackbar open={snackbar.isOpen} autoHideDuration={6000} onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }}>
            <Alert onClose={() => { setSnackbar((pre) => ({ ...pre, isOpen: false })) }} severity={snackbar.type}>
                {snackbar.message}
            </Alert>
        </Snackbar>
    
    <div className="App p-5">
      {/* <h1 className="h3">Jobs</h1> */}
      <table className="table shad table-striped mt-3">
        <thead>
          <tr style={{ background: "#F3F6F9" }}>
            <th
              scope="col"
              colspan="5"
              className="text-left pl-4"
              style={{ fontSize: "24px", fontWeight: "600" }}
            >
              Jobs List
            </th>
            <th scope="col" colspan="3" className="text-right pr-4">
              {/* New Modal Open */}

              <Button
                onClick={handleOpen}
                color="info"
                variant="contained"
                className="text-white"
                style={{ backgroundColor: "#3783E7" }}
              >
                Add New Job
              </Button>
              <Modal
                className="border d-flex justify-content-center align-items-center"
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <Box
                  sx={{ ...style }}
                  style={{ width: "max-content", background: "white", borderRadius: "20px" }}
                >
                  {/* <button onClick={handleClose}>x</button> */}
                  <header>
                    <Box
                      className="d-flex justify-content-between"
                      style={{
                        background: "#F3F6F9",
                        padding: "20px 35px",
                        borderTopRightRadius: "20px",
                        borderTopLeftRadius: "20px",
                      }}
                    >
                      <Box className="d-flex flex-column text-black justify-content-start">
                        <h2
                          className="modal-title text-left font-weight-bold"
                          id="exampleModalLongTitle"
                        >
                          {editId == null ? 'Add Job' : 'Edit Job'}
                        </h2>
                        <p className="">Enter job posting details below:</p>
                      </Box>
                      <button
                        type="button"
                        className="close text-black font-weight-light"
                        data-dismiss="modal"
                        onClick={handleClose}
                        style={{ fontSize: "40px" }}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </Box>
                  </header>
                  <Box className="" style={{ padding: "20px 35px" }}>
                    <Box className="d-flex">
                      <Box>
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Company
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter Company"
                          id="bootstrap-input"
                          className="mt-2 rounded-0 inp"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.company}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, company: event.target.value}))}}
                        />
                      </Box>
                      <Box className="mx-3">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Location
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter Location"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.location}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, location: event.target.value}))}}
                        />
                      </Box>
                      <Box className="w-full">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Status
                        </InputLabel>

                        <select
                          className="custom-select sele mt-2"
                          id="inputGroupSelect01"
                          style={{
                            width: "220px",
                            height: "42px",
                            background: "#fff",
                          }}
                          value={addJobTracking.status}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, status: event.target.value}))}}
                        >
                          <option selected>Select Status</option>
                          <option value="Active">Active</option>
                          <option value="Completed">Completed</option>
                          <option value="Draft">Draft</option>
                        </select>
                        {/* <Select
                          className="mt-2"
                          style={{
                            width: "220px",
                            height: "42px",
                            background: "#fff",
                          }}
                          id="demo-simple-select"
                          placeholder="Hello World"
                        >
                          <MenuItem value={"apllied"}>Applied</MenuItem>
                          <MenuItem value={"not-applied"}>Not Applied</MenuItem>
                        </Select> */}
                      </Box>
                    </Box>
                    <Box className="d-flex" style={{ marginTop: "40px" }}>
                      <Box>
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Role/Position
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter role/position"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.rolePosition}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, rolePosition: event.target.value}))}}
                        />
                      </Box>
                      <Box className="mx-3">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Main Contact
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter contact"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.mainContact}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, mainContact: event.target.value}))}}
                        />
                      </Box>
                      <Box className="w-full">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Phone
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter phone"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.phone}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, phone: event.target.value}))}}
                        />
                      </Box>
                    </Box>
                    <Box className="d-flex" style={{ marginTop: "40px" }}>
                      <Box>
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Email
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter email"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.email}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, email: event.target.value}))}}
                        />
                      </Box>
                      <Box className="mx-3">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Date Applied
                        </InputLabel>
                        <BootstrapInput
                          type="date"
                          placeholder="Enter contact"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.dateApplied}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, dateApplied: event.target.value}))}}
                        />
                      </Box>
                      <Box className="w-full">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Date Contact
                        </InputLabel>
                        <BootstrapInput
                          type="date"
                          placeholder="Enter phone"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.dateContact}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, dateContact: event.target.value}))}}
                        />
                      </Box>
                    </Box>
                    <Box className="d-flex" style={{ marginTop: "40px" }}>
                      <Box>
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Job Link
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Enter link"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                          value={addJobTracking.jobLink}
                          onChange={(event)=>{event.preventDefault(); event.persist(); setAddJobTracking((pre)=>({...pre, jobLink: event.target.value}))}}
                        />
                      </Box>
                      {/* <Box className="mx-3">
                        <InputLabel
                          htmlFor="bootstrap-input"
                          className="mb-0 labe"
                        >
                          Last Update by
                        </InputLabel>
                        <BootstrapInput
                          placeholder="Select Name"
                          id="bootstrap-input"
                          className="mt-2 rounded-0"
                          style={{ width: "220px", height: "42px" }}
                        />
                      </Box> */}
                    </Box>
                    {/* <Box className="" style={{ marginTop: "40px" }}>
                      <InputLabel
                        htmlFor="bootstrap-input"
                        className="mb-0 labe"
                      >
                        Tags
                      </InputLabel>
                      <Box className="mt-1">
                        <span onClick={()=>{handleAddTag('full-time')}} class={`badge badge-pill badge-white border p-2 pill-style mr-1 ${addJobTracking.tags.includes('full-time') && 'active-pill-tag'}`} >
                          full-time 1
                        </span>
                        <span onClick={()=>{handleAddTag('Onsite')}} class={`badge badge-pill badge-white border p-2 pill-style mr-1 ${addJobTracking.tags.includes('Onsite') && 'active-pill-tag'}`}>
                          Onsite
                        </span>
                        <span onClick={()=>{handleAddTag('Benifits')}} class={`badge badge-pill badge-white border p-2 pill-style mr-1 ${addJobTracking.tags.includes('Benifits') && 'active-pill-tag'}`}>
                          Benifits
                        </span>
                        <span onClick={()=>{handleAddTag('Funding')}} class={`badge badge-pill badge-white border p-2 pill-style ml-1 ${addJobTracking.tags.includes('Funding') && 'active-pill-tag'}`}>
                          Funding
                        </span>
                      </Box>
                    </Box> */}
                    <Box className="d-flex" style={{ marginTop: "40px" }}>
                      <Button
                        className="btn w-50 py-3 mr-2"
                        style={{
                          border: "2px solid #3783E7",
                          color: "#3783E7",
                          borderRadius: "2px",
                        }}
                        onClick={()=>{handleClose()}}
                      >
                        Cancel
                      </Button>
                      <Button
                        className="btn text-white w-50 py-3 ml-2"
                        style={{ backgroundColor: "#3783E7" }}
                        onClick={()=>{handleAddJobTracking()}}
                        disabled={addPending}
                      >
                        {editId == null ? 'Save' : 'Update'}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Modal>
            </th>
          </tr>
          <tr>
            <th scope="row">Company</th>
            <th>Location</th>
            <th>Status</th>
            <th>Role/Position</th>
            <th>Main Content</th>
            <th>Phone</th>
            <th>Email</th>
            <th className="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pending ? <>
            <tr>
            <td colSpan={7}>
              <div className="w-100 d-flex align-items-center justify-content-between mb-2">
                <div
                  class="spinner-border text-danger mx-auto"
                  role="status"
                ></div>
              </div>
            </td>
          </tr>
          </>: <>
          {list.map((item, Index) => {
            return (
              <tr key={Index} className="py-3">
                <td>{item.company || 'N/A'}</td>
                <td>{item.location || 'N/A'}</td>
                <td>{item.status || 'N/A'}</td>
                <td>{item.rolePosition || 'N/A'}</td>
                <td>{item.mainContact || 'N/A'}</td>
                <td>{item.phone || 'N/A'}</td>
                <td>{item.email || 'N/A'}</td>
                <td>
                <Button
                    variant="contained"
                    style={{backgroundColor: '#28a745', color: 'white'}}
                    startIcon={editId == item._id ? false : <EditIcon />}
                    onClick={()=>{setEditModal(item)}} 
                    disabled={editId == item._id}
                  >
                    {editId == item._id ? <CircularProgress style={{color: 'white'}} size={22} /> : 'Edit'}
                  </Button>
                <Button
                    variant="contained"
                    style={{backgroundColor: 'rgb(220, 0, 78)', color: 'white', marginLeft: '5px'}}
                    startIcon={deleteId == item._id ? false : <DeleteIcon />}
                    onClick={()=>{handleDeleteJobTracking(item)}} 
                    disabled={deleteId == item._id}
                  >
                    {deleteId == item._id ? <CircularProgress style={{color: 'white'}} size={22} /> : "Delete"}
                  </Button>
                  {/* <button className='btn btn-success btn-sm rounded-0 font2  mr-2' onClick={()=>{setEditModal(item)}} disabled={editId == item._id}><FaEdit /></button>
                  <button className='btn btn-danger btn-sm rounded-0 font2' onClick={()=>{handleDeleteJobTracking(item)}} disabled={deleteId == item._id}><AiFillDelete /></button> */}
                  {/* <ul class="list-inline m-0">
                      <li class="list-inline-item">
                          <button class="btn btn-primary btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Add"><i class="fa fa-table"></i></button>
                      </li>
                      <li class="list-inline-item">
                          <button class="btn btn-success btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Edit"><i class="fa fa-edit"></i></button>
                      </li>
                      <li class="list-inline-item">
                          <button class="btn btn-danger btn-sm rounded-0" type="button" data-toggle="tooltip" data-placement="top" title="Delete"><i class="fa fa-trash"></i></button>
                      </li>
                  </ul> */}
                </td>
              </tr>
            );
          })}
          </>}
          {!pending && list.length == 0 && <tr className="py-3">
            <td colSpan={7} align="center">No Job Tracking available</td>
          </tr>}
         
        </tbody>
      </table>
    </div>
    </>
  );
}

export default JobTrackerM;
